module.exports = __webpack_public_path__ + "img/twitter-square-brands-white.b9f518c8.png";